import { styled } from '@mui/material/styles'
import { theme } from '../../../modules/App/Providers/Theme/theme'

const Animation = styled('div')`
  animation: pulsate 1.5s ease-out;
  animation-iteration-count: infinite;

  /* you dont need the stuff below, but its what I used to create the loading circle */
  border: 3px solid ${theme.palette.grey[400]};
  border-radius: 30px;
  height: 0.375rem;
  width: 0.375rem;
  position: relative;
  display: inline-block;
  text-align: center;

  @keyframes pulsate {
    0% {
      transform: scale(0.1, 0.1);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: scale(1.2, 1.2);
      opacity: 0;
    }
  }
`

export { Animation }
